import { render, staticRenderFns } from "./OSelectInput.vue?vue&type=template&id=15031a39&scoped=true&"
import script from "./OSelectInput.vue?vue&type=script&lang=js&"
export * from "./OSelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15031a39",
  null
  
)

export default component.exports